import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import RookPiercingImage from '../../Assets/Piercing Services/rook piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function RookPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Rook Piercing UAE | 150-175 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Rook Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Rook Piercing 150-175 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={RookPiercingImage} alt="Rook Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Rook Piercing</h3>

          <p>
            Enhance your ear styling with our professional rook piercing services in the UAE, available at an affordable price range of 150–175 AED. Rook piercing is a trendy and stylish cartilage piercing located in the anti-helix, the inner ridge of the ear, offering a unique and modern look that stands out while maintaining elegance. This distinctive placement makes rook piercing a popular choice for individuals who want to add depth and character to their ear design without going for more common styles. Whether you prefer a curved barbell or a minimal jewelry piece, our expert specialists ensure precise placement for a balanced and visually appealing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each rook piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Our goal is to provide a quick, efficient, and pain-minimized procedure, making rook piercing suitable for both first-time clients and those looking to expand their ear piercing collection with a unique touch.
          </p>

          <p>
            Rook piercing is ideal for individuals who want a bold yet refined addition to their ear styling. Its placement within the ear structure allows it to pair beautifully with other piercings such as helix, tragus, conch, or lobe, helping you create a curated and layered ear look. Our specialists take the time to understand your preferences and guide you in choosing the best placement and jewelry options to suit your ear anatomy and personal style. This personalized approach ensures that your piercing complements your overall look perfectly
          </p>

          <p>
            The procedure is typically completed within minutes, though it requires expert precision due to its location. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, ensuring that you can enjoy your new piercing with minimal stress. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings like the rook can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your rook piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your rook piercing will heal effectively and remain a stylish and long-lasting feature of your ear design.
          </p>

          <p>
            Our rook piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted rook piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a trendy and unique look effortlessly. Book your rook piercing appointment today and elevate your ear styling with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Rook Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default RookPiercing;